// best-in-category-chart.tsx
import { AnalyticsChart } from "./analytics-chart";
import { MetricTerm }     from "../metric-term";
import { useBestInCategoryData } from "@/app/hooks/analytics/useBestInCategoryData";
import { getPerformanceEvents } from "@/app/data/performance-events";

interface Props {
  antennaData?:          any;
  selectedModels?:       string[];
  brandName?:            string;
  onNavigateToInsights?: () => void;
  projectionDate?:       string | null;
}

export function BestInCategoryChart({ antennaData, selectedModels, brandName, onNavigateToInsights, projectionDate }: Props) {
  const { data, isLoading, error } = useBestInCategoryData("full", antennaData, selectedModels);

  const events = getPerformanceEvents(brandName);

  return (
    <AnalyticsChart
      timeSeriesData={data?.timeSeriesData ?? []}
      selectedModels={data?.selectedModels ?? []}
      isLoading={isLoading}
      error={error}
      metricUnit="%"
      metricName="Top 5 Rate"
      insightContext="top 5 rate"
      brandName={brandName}
      onNavigateToInsights={onNavigateToInsights}
      events={events}
      projectionDate={projectionDate}
      isIllustrative={data?.isSynthetic}
      incompleteRuns={data?.incompleteRuns}
      rebaselineMarks={data?.rebaselineMarks}
      metricTitle={
        <MetricTerm
          definition="The share of responses where your brand appears in the top 5 named options. This measures whether you make the AI consideration set."
          calculation="Responses where your brand is listed among the first 5 brands named, divided by total responses that include a ranked list, averaged across the AI models measured in this run."
          interpretation="Being in the top 5 is the threshold for active consideration. A sharp drop from Mention Rate to Top 5 Rate means the brand is mentioned but not placed competitively. Models know you but do not rank you."
          goodRange="60% or higher is strong. 40-59% is competitive. Below 40% means you're being mentioned but not making the shortlist."
          onOpenAIChat={() => {}}
        >
          Top 5 Rate
        </MetricTerm>
      }
    />
  );
}